import Vue from "vue";
import Router from "vue-router";
// import axios from "axios";
// import { rejects } from "assert";
// import loginUrl from "/config"
// const innerLayout = () => import("@/views/layout/inner_layout");
const Layout = () => import("@/views/layout/layout");
//横向nav时，打开下句
// const Layout = () =>
//   import ("@/views/layout/layout_horizontal");

Vue.use(Router);
const constantRouterMap = [
  {
    path: "/login",
    component: () =>
      ({
        login: import("@/views/login/login"),
        login_zj: import("@/views/login/login_zj"),
        login_dog: import("@/views/login/login_dog"),
        login_wd: import("@/views/login/login_wd")
      }[window.getProjectName()]),

    hidden: true
  },
  {
    path: "/sso/logout",
    hidden: true,
    component: () => import("@/views/login/logout")
  },
  {
    path: "/404",
    component: () => import("@/views/errorPage/404"),
    hidden: true
  },
  {
    path: "*",
    redirect: "/404",
    hidden: true
  },
  {
    path: "/jcsz",
    component: Layout,
    redirect: "/jcsz/spmb",
    meta: {
      title: "基础设置",
      icon: "el-icon-setting"
    },
    children: [
      {
        path: "nav/:path",
        component: () => import("@/views/manage/nav"),
        name: "nav",
        meta: {
          title: "导航",
          icon: "nav"
        }
      },
      {
        path: "jymxLook",
        component: () => import("@/views/jcsz/jymcLook"),
        name: "jymxLook",
        meta: {
          title: "交易明细管理",
          icon: ""
        }
      },
      {
        path: "dzqmgl",
        component: () => import("@/views/jcsz/dzqmgl"),
        name: "dzqmgl",
        meta: {
          title: "电子签名管理",
          icon: ""
        }
      },
      {
        path: "xnzhfz",
        component: () => import("@/views/jcsz/xnzhfz"),
        name: "xnzhfz",
        meta: {
          title: "虚拟账户辅助统计",
          icon: ""
        }
      },
      {
        path: "spmb",
        component: () => import("@/views/jcsz/spmb"),
        name: "spmb",
        meta: {
          title: "审批模板",
          icon: ""
        }
      },
      {
        path: "zzsz",
        component: () => import("@/views/jcsz/zzsz"),
        name: "zzsz",
        meta: {
          title: "制单金额配置",
          icon: ""
        }
      },
      {
        path: "gsl",
        component: () => import("@/views/jcsz/gsl"),
        name: "gsl",
        meta: {
          title: "公示栏编辑",
          icon: ""
        }
      },
      {
        path: "gslDetail",
        component: () => import("@/views/jcsz/gslDetail"),
        name: "gslDetail",
        meta: {
          title: "公示栏编辑",
          icon: ""
        }
      },
      {
        path: "zfmb",
        component: () => import("@/views/jcsz/zfmb"),
        name: "zfmb",
        meta: {
          title: "支付模板",
          icon: ""
        }
      },
      {
        path: "zhid",
        component: () => import("@/views/jcsz/zhid"),
        name: "zhid",
        meta: {
          title: "制单",
          icon: ""
        }
      },
      {
        path: "yhzh",
        component: () => import("@/views/jcsz/yhzh"),
        name: "yhzh",
        meta: {
          title: "银行账户",
          icon: ""
        }
      },
      {
        path: "yhxx",
        component: () => import("@/views/jcsz/yhxx"),
        name: "yhxx",
        meta: {
          title: "银行信息",
          icon: ""
        }
      },
      {
        path: "khhgl",
        component: () => import("@/views/jcsz/khhgl"),
        name: "khhgl",
        meta: {
          title: "开户行管理",
          icon: ""
        }
      },
      {
        path: "yhk",
        component: () => import("@/views/jcsz/yhk"),
        name: "yhk",
        meta: {
          title: "我的银行卡",
          icon: ""
        }
      },
      {
        path: "skr",
        component: () => import("@/views/jcsz/skr"),
        name: "skr",
        meta: {
          title: "收款人管理",
          icon: ""
        }
      },
      {
        path: "zdgzh",
        component: () => import("@/views/jcsz/zdgzh"),
        name: "zdgzh",
        meta: {
          title: "镇代管账户管理",
          icon: ""
        }
      },
      {
        path: "czhgl",
        component: () => import("@/views/jcsz/czhgl"),
        name: "czhgl",
        meta: {
          title: "村账号管理",
          icon: ""
        }
      },
      {
        path: "zzhgl",
        component: () => import("@/views/jcsz/zzhgl"),
        name: "zzhgl",
        meta: {
          title: "镇账号管理",
          icon: ""
        }
      },
      {
        path: "cmkgl",
        component: () => import("@/views/jcsz/cmkgl"),
        name: "cmkgl",
        meta: {
          title: "村民卡管理",
          icon: ""
        }
      },
      {
        path: "cwkgl",
        component: () => import("@/views/jcsz/cwkgl"),
        name: "cwkgl",
        meta: {
          title: "村务卡管理",
          icon: ""
        }
      },
      {
        path: "idCardManage",
        component: () => import("@/views/jcsz/idCardManage"),
        name: "idCardManage",
        meta: {
          title: "身份证管理",
          icon: ""
        }
      },
      {
        path: "gysgl",
        component: () => import("@/views/jcsz/gysgl"),
        name: "gysgl",
        meta: {
          title: "收款人管理",
          icon: ""
        }
      },
      {
        path: "gcxmgl",
        component: () => import("@/views/jcsz/gcxmgl/gcxmgl"),
        name: "gcxmgl",
        meta: {
          title: "工程项目管理",
          icon: ""
        }
      },
      {
        path: "yhzhbmd",
        component: () => import("@/views/jcsz/yhzhbmd"),
        name: "yhzhbmd",
        meta: {
          title: "银行账户白名单",
          icon: ""
        }
      },
      {
        path: "zstzh",
        component: () => import("@/views/jcsz/zstzh"),
        name: "zstzh",
        meta: {
          title: "镇实体账户",
          icon: ""
        }
      },
      {
        path: "cstzh",
        component: () => import("@/views/jcsz/cstzh"),
        name: "cstzh",
        meta: {
          title: "村实体账户",
          icon: ""
        }
      }
    ]
  },
  {
    path: "/manage",
    component: Layout,
    redirect: "/manage/user",
    meta: {
      title: "系统管理",
      icon: "el-icon-tickets"
    },
    children: [
      {
        path: "nav/:path",
        component: () => import("@/views/manage/nav"),
        name: "nav",
        meta: {
          title: "导航",
          icon: "nav"
        }
      },
      {
        path: "dogfp",
        component: () => import("@/views/manage/dogfp"),
        name: "dogfp",
        meta: {
          title: "加密狗配置",
          icon: ""
        }
      },
      {
        path: "jjzzfp",
        component: () => import("@/views/manage/jjzzfp"),
        name: "jjzzfp",
        meta: {
          title: "经济组织分配",
          icon: ""
        }
      },
      {
        path: "jjzzgl",
        component: () => import("@/views/manage/jjzzgl"),
        name: "jjzzgl",
        meta: {
          title: "经济组织新建",
          icon: ""
        }
      },
      {
        path: "transaction",
        component: () => import("@/views/manage/transaction"),
        name: "transaction",
        meta: {
          title: "交易管理",
          icon: ""
        }
      },
      {
        path: "user",
        component: () => import("@/views/manage/user"),
        name: "user",
        meta: {
          title: "用户管理",
          icon: ""
        }
      },
      {
        path: "user_wb",
        component: () => import("@/views/manage/user_wb"),
        name: "user_wb",
        meta: {
          title: "用户管理",
          icon: ""
        }
      },
      {
        path: "source",
        component: () => import("@/views/manage/source"),
        name: "source",
        meta: {
          title: "资源管理",
          icon: ""
        }
      },
      {
        path: "role",
        component: () => import("@/views/manage/role"),
        name: "role",
        meta: {
          title: "角色管理",
          icon: ""
        }
      },
      {
        path: "dict",
        component: () => import("@/views/manage/dict"),
        name: "dict",
        meta: {
          title: "字典管理",
          icon: ""
        }
      },
      {
        path: "htxxDetail",
        component: () => import("@/views/manage/htxxDetail"),
        name: "htxxDetail",
        meta: {
          title: "后台信息",
          icon: ""
        }
      },
      {
        path: "xzqhgl",
        component: () => import("@/views/manage/xzqhgl"),
        name: "xzqhgl",
        meta: {
          title: "行政区划管理",
          icon: ""
        }
      },
      {
        path: "fjmbwh",
        component: () => import("@/views/manage/fjmbwh"),
        name: "fjmbwh",
        meta: {
          title: "附件模板维护",
          icon: ""
        }
      }
    ]
  },
  {
    path: "/srgl",
    component: Layout,
    redirect: "/manage/jspz",
    meta: {
      title: "收入管理",
      icon: "el-icon-tickets"
    },
    children: [
      {
        path: "nav/:path",
        component: () => import("@/views/manage/nav"),
        name: "nav",
        meta: {
          title: "导航",
          icon: "nav"
        }
      },
      {
        path: "jspz",
        component: () => import("@/views/srgl/jspz"),
        name: "jspz",
        meta: {
          title: "结算凭证",
          icon: ""
        }
      },
      {
        path: "zjskd",
        component: () => import("@/views/srgl/zjskd"),
        name: "zjskd",
        meta: {
          title: "资金收款单",
          icon: ""
        }
      },
      {
        path: "srdzd",
        component: () => import("@/views/srgl/srdzd"),
        name: "srdzd",
        meta: {
          title: "收入对账单",
          icon: ""
        }
      }
    ]
  },
  {
    path: "/yhpz",
    component: Layout,
    redirect: "/yhpz/yhcs",
    meta: {
      title: "银行配置",
      icon: "el-icon-tickets"
    },
    children: [
      {
        path: "nav/:path",
        component: () => import("@/views/manage/nav"),
        name: "nav",
        meta: {
          title: "导航",
          icon: "nav"
        }
      },
      {
        path: "yhcs",
        component: () => import("@/views/yhpz/yhcs"),
        name: "yhcs",
        meta: {
          title: "银行参数",
          icon: ""
        }
      },
      {
        path: "jyrz",
        component: () => import("@/views/yhpz/jyrz"),
        name: "jyrz",
        meta: {
          title: "交易日志",
          icon: ""
        }
      }
    ]
  },
  {
    path: "/nbjspz",
    component: Layout,
    redirect: "/nbjspz/pzdj",
    meta: {
      title: "内部凭证",
      icon: "el-icon-tickets"
    },
    children: [
      {
        path: "nav/:path",
        component: () => import("@/views/manage/nav"),
        name: "nav",
        meta: {
          title: "导航",
          icon: "nav"
        }
      },
      {
        path: "pzdj",
        component: () => import("@/views/nbjspz/pzdj"),
        name: "pzdj",
        meta: {
          title: "登记",
          icon: ""
        }
      },
      {
        path: "pzsy",
        component: () => import("@/views/nbjspz/pzsy"),
        name: "pzsy",
        meta: {
          title: "使用",
          icon: ""
        }
      },
      {
        path: "rkmx",
        component: () => import("@/views/nbjspz/rkmx"),
        name: "rkmx",
        meta: {
          title: "入库明细",
          icon: ""
        }
      },
      {
        path: "ckmx",
        component: () => import("@/views/nbjspz/ckmx"),
        name: "ckmx",
        meta: {
          title: "出库明细",
          icon: ""
        }
      }
    ]
  },
  {
    path: "/tjbb",
    component: Layout,
    redirect: "/tjbb/zjzctj",
    meta: {
      title: "统计报表",
      icon: "el-icon-setting"
    },
    children: [
      {
        path: "nav/:path",
        component: () => import("@/views/manage/nav"),
        name: "nav",
        meta: {
          title: "导航",
          icon: "nav"
        }
      },
      {
        path: "rjz",
        component: () => import("@/views/tjbb/rjz"),
        name: "rjz",
        meta: {
          title: "日记账",
          // keepAlive: true,
          icon: ""
        }
      },
      {
        path: "zjzctj",
        component: () => import("@/views/tjbb/zjzctj"),
        name: "zjzctj",
        meta: {
          title: "资金支出统计",
          // keepAlive: true,
          icon: ""
        }
      },
      {
        path: "pztj/:lvCode?/:isActive?",
        component: () => import("@/views/tjbb/pztj"),
        name: "pztj",
        meta: {
          title: "资金收入统计",
          keepAlive: true,
          icon: ""
        }
      },
      {
        path: "zjsrtj/:lvCode?/:isActive?",
        component: () => import("@/views/tjbb/zjsrtj"),
        name: "zjsrtj",
        meta: {
          title: "资金收入统计",
          keepAlive: true,
          icon: ""
        }
      },
      {
        path: "jjzz/:code/:ksdate*/:jsdate*/:lvCode?/:isActive?/:jjzzname?",
        component: () => import("@/views/tjbb/jjzz"),
        name: "jjzz",
        hidden: true,
        meta: {
          title: "资金统计",
          icon: ""
        }
      },
      {
        path: "zccx",
        component: () => import("@/views/tjbb/zccx"),
        name: "zccx",
        hidden: true,
        meta: {
          title: "支出查询",
          icon: ""
        }
      },
      {
        path: "srcx",
        component: () => import("@/views/tjbb/srcx"),
        name: "srcx",
        hidden: true,
        meta: {
          title: "收入查询",
          icon: ""
        }
      },
      {
        path: "zjsrlb/:jzcode?/:lvCode?/:isActive?/:jjzzname?",
        component: () => import("@/views/tjbb/zjsrlb"),
        name: "zjsrlb",
        hidden: true,
        meta: {
          title: "资金收入列表",
          icon: ""
        }
      },
      {
        path: "pztjlb/:jzcode?/:lvCode?/:isActive?/:start?/:end?/:xzname?",
        component: () => import("@/views/tjbb/pztjlb"),
        name: "pztjlb",
        hidden: true,
        meta: {
          title: "凭证统计列表",
          icon: ""
        }
      }
    ]
  },
  {
    path: "/yhhpdj",
    component: Layout,
    redirect: "/yhhpdj/yhhpdj",
    meta: {
      title: "银行汇票登记",
      icon: ""
    },
    children: [
      {
        path: "nav/:path",
        component: () => import("@/views/manage/nav"),
        name: "nav",
        meta: {
          title: "导航",
          icon: "nav"
        }
      },
      {
        path: "yhhpdj",
        component: () => import("@/views/yhhpdj/yhhpdj"),
        name: "yhhpdj",
        meta: {
          title: "银行汇票登记",
          icon: ""
        }
      }
    ]
  },
  {
    path: "/byjgl",
    component: Layout,
    redirect: "/byjgl/byjgl",
    meta: {
      title: "备用金管理",
      icon: ""
    },
    children: [
      {
        path: "nav/:path",
        component: () => import("@/views/manage/nav"),
        name: "nav",
        meta: {
          title: "导航",
          icon: "nav"
        }
      },
      {
        path: "byjgl",
        component: () => import("@/views/byjgl/byjgl"),
        name: "byjgl",
        meta: {
          title: "备用金管理",
          icon: ""
        }
      },
      {
        path:
          "byj_mode_xjtx/:spmbId?/:sqrid?/:sqrxm?/:path?/:mblx?/:mblxNum?/:sqlsh?/:id?/:sqsm?/:by2?/:by3?/:by5?/:by6?/:sqlx?/:sfsp?/:version?/:zfrid?",
        component: () => import("@/views/wdsq/dbsq_mode_xjtx"),
        name: "byj_mode_xjtx",
        meta: {
          title: "备用金",
          icon: ""
        }
      },
      {
        path:
          "byj_mode_xjsy/:spmbId?/:sqrid?/:sqrxm?/:path?/:mblx?/:mblxNum?/:sqlsh?/:id?/:sqsm?/:by2?/:by3?/:by5?/:by6?/:sqlx?/:sfsp?/:version?/:zfrid?",
        component: () => import("@/views/wdsq/dbsq_mode_xjsy"),
        name: "byj_mode_xjsy",
        meta: {
          title: "备用金",
          icon: ""
        }
      }
    ]
  },
  {
    path: "/ynzl",
    component: Layout,
    redirect: "/ynzl/dwzf",
    meta: {
      title: "银农直连",
      icon: "el-icon-setting"
    },
    children: [
      {
        path: "nav/:path",
        component: () => import("@/views/manage/nav"),
        name: "nav",
        meta: {
          title: "导航",
          icon: "nav"
        }
      },
      {
        path: "dzxxtable",
        component: () => import("@/views/ynzl/dzxxtable"),
        name: "dzxxtable",
        meta: {
          title: "对账信息",
          icon: ""
        }
      },
      {
        path: "dzxx/:date",
        component: () => import("@/views/ynzl/dzxx"),
        name: "dzxx",
        meta: {
          title: "对账信息详情",
          icon: ""
        }
      },
      {
        path: "zzjl",
        component: () => import("@/views/ynzl/zzjl"),
        name: "zzjl",
        meta: {
          title: "转账记录",
          icon: ""
        }
      },
      {
        path: "dwzf",
        component: () => import("@/views/ynzl/dwzf"),
        name: "dwzf",
        meta: {
          title: "待我支付",
          icon: ""
        }
      },
      {
        path:
          "dbsq_mode/:path?/:mblx?/:mblxNum?/:sqlsh?/:sfsp?/:upShowhide?/:id?/:scjd?",
        component: () => import("@/views/wdsq/dbsq_mode"),
        name: "dwzf_mode_three",
        meta: {
          title: "支付",
          icon: ""
        }
      },
      {
        path:
          "dbsq_mode_gz/:path?/:mblx?/:mblxNum?/:sqlsh?/:sfsp?/:upShowhide?/:id?",
        component: () => import("@/views/wdsq/dbsq_mode_gz"),
        name: "dwzf_mode_gz",
        meta: {
          title: "支付",
          icon: ""
        }
      },
      {
        path:
          "dbsq_mode_xnzz/:path?/:mblx?/:mblxNum?/:sqlsh?/:sfsp?/:upShowhide?/:id?",
        component: () => import("@/views/wdsq/dbsq_mode_xnzz"),
        name: "dwzf_mode_xnzz",
        meta: {
          title: "支付",
          icon: ""
        }
      },
      {
        path:
          "dbsq_mode_mz/:path?/:mblx?/:mblxNum?/:sqlsh?/:sfsp?/:upShowhide?/:id?",
        component: () => import("@/views/wdsq/dbsq_mode_mz"),
        name: "dwzf_mode_mz",
        meta: {
          title: "支付",
          icon: ""
        }
      },
      {
        path:
          "dbsq_mode_pldf/:path?/:mblx?/:mblxNum?/:sqlsh?/:sfsp?/:upShowhide?/:id?/:scjd?",
        component: () => import("@/views/wdsq/dbsq_mode_pldf"),
        name: "dwzf_mode_pldf",
        meta: {
          title: "支付",
          icon: ""
        }
      },
      {
        path:
          "dbsq_mode_xjtx/:path?/:mblx?/:mblxNum?/:sqlsh?/:sfsp?/:upShowhide?/:id?",
        component: () => import("@/views/wdsq/dbsq_mode_xjtx"),
        name: "dwzf_mode_xjtx",
        meta: {
          title: "支付",
          icon: ""
        }
      },
      {
        path:
          "dbsq_mode_xjsy/:path?/:mblx?/:mblxNum?/:sqlsh?/:sfsp?/:upShowhide?/:id?",
        component: () => import("@/views/wdsq/dbsq_mode_xjsy"),
        name: "dwzf_mode_xjsy",
        meta: {
          title: "支付",
          icon: ""
        }
      },
      {
        path:
          "dbsq_mode_hp/:path?/:mblx?/:mblxNum?/:sqlsh?/:sfsp?/:upShowhide?/:id?",
        component: () => import("@/views/wdsq/dbsq_mode_hp"),
        name: "dwzf_mode_hp",
        meta: {
          title: "支付",
          icon: ""
        }
      },
      {
        path:
          "dwzf_modal/:sqbId/:version/:spmbId/:sqrid/:sqrxm/:sqsm/:by2/:by3/:by5?/:by6/:sqlsh/:path",
        component: () => import("@/views/ynzl/dwzf_modal"),
        name: "dwzf_modal",
        meta: {
          title: "待我支付",
          icon: ""
        }
      },
      {
        path:
          "zfjg_modal/:spbId/:version/:spmbId/:sqrid/:sqrxm/:sqsm/:by2/:by3/:by5?/:by6/:sqlsh+/:path",
        component: () => import("@/views/ynzl/zfjg_modal"),
        name: "zfjg_modal",
        meta: {
          title: "支付结果",
          icon: ""
        }
      },
      {
        path: "zfjl",
        component: () => import("@/views/ynzl/zfjl"),
        name: "zfjl",
        meta: {
          title: "支付记录",
          icon: ""
        }
      },
      {
        path: "dezf",
        component: () => import("@/views/ynzl/dezf"),
        name: "dezf",
        meta: {
          title: "大额支付",
          icon: ""
        }
      },
      {
        path: "dezf_modal",
        component: () => import("@/views/ynzl/dezf_modal"),
        name: "dezf_modal",
        meta: {
          title: "大额支付",
          icon: ""
        }
      },
      {
        path: "rzdz",
        component: () => import("@/views/ynzl/rzdz"),
        name: "rzdz",
        meta: {
          title: "日终对账",
          icon: ""
        }
      }
    ]
  },
  {
    path: "/spgl",
    component: Layout,
    redirect: "/spgl/dwsp",
    meta: {
      title: "审批管理",
      icon: "el-icon-setting"
    },
    children: [
      {
        path: "nav/:path",
        component: () => import("@/views/manage/nav"),
        name: "nav",
        meta: {
          title: "导航",
          icon: "nav"
        }
      },
      {
        path: "dwsp",
        component: () => import("@/views/spgl/dwsp"),
        name: "dwsp",
        meta: {
          title: "待我审批",
          icon: ""
        }
      },
      {
        path: "dbsq_mode/:path?/:mblx?/:mblxNum?/:sqlsh?/:sfsp?/:id?/:scjd?",
        component: () => import("@/views/wdsq/dbsq_mode"),
        name: "dwsp_mode_three",
        meta: {
          title: "审批",
          icon: ""
        }
      },
      {
        path:
          "dbsq_mode_xnzz/:path?/:mblx?/:mblxNum?/:sqlsh?/:sfsp?/:id?/:scjd?",
        component: () => import("@/views/wdsq/dbsq_mode_xnzz"),
        name: "dwsp_mode_gz",
        meta: {
          title: "审批",
          icon: ""
        }
      },
      {
        path: "dbsq_mode_mz/:path?/:mblx?/:mblxNum?/:sqlsh?/:sfsp?/:id?/:scjd?",
        component: () => import("@/views/wdsq/dbsq_mode_mz"),
        name: "dwsp_mode_mz",
        meta: {
          title: "审批",
          icon: ""
        }
      },
      {
        path:
          "dbsq_mode_pldf/:path?/:mblx?/:mblxNum?/:sqlsh?/:sfsp?/:id?/:scjd?",
        component: () => import("@/views/wdsq/dbsq_mode_pldf"),
        name: "dwsp_mode_pldf",
        meta: {
          title: "审批",
          icon: ""
        }
      },
      {
        path:
          "dbsq_mode_xjtx/:path?/:mblx?/:mblxNum?/:sqlsh?/:sfsp?/:id?/:scjd?",
        component: () => import("@/views/wdsq/dbsq_mode_xjtx"),
        name: "dwsp_mode_xjtx",
        meta: {
          title: "审批",
          icon: ""
        }
      },
      {
        path:
          "dbsq_mode_xjsy/:path?/:mblx?/:mblxNum?/:sqlsh?/:sfsp?/:id?/:scjd?",
        component: () => import("@/views/wdsq/dbsq_mode_xjsy"),
        name: "dwsp_mode_xjsy",
        meta: {
          title: "审批",
          icon: ""
        }
      },
      {
        path: "dbsq_mode_hp/:path?/:mblx?/:mblxNum?/:sqlsh?/:sfsp?/:id?/:scjd?",
        component: () => import("@/views/wdsq/dbsq_mode_hp"),
        name: "dwsp_mode_hp",
        meta: {
          title: "审批",
          icon: ""
        }
      },
      {
        path:
          "dbsq_mode_bksq/:path?/:mblx?/:mblxNum?/:sqlsh?/:sfsp?/:id?/:scjd?",
        component: () => import("@/views/wdsq/dbsq_mode_bksq"),
        name: "dwsp_mode_bksq",
        meta: {
          title: "审批",
          icon: ""
        }
      },
      {
        path:
          "dbsq_mode_xnzz/:path?/:mblx?/:mblxNum?/:sqlsh?/:sfsp?/:id?/:scjd?",
        component: () => import("@/views/wdsq/dbsq_mode_xnzz"),
        name: "dwsp_mode_xnzz",
        meta: {
          title: "审批",
          icon: ""
        }
      },
      {
        path:
          "dwsp_modal/:spbId+/:version/:spmbId/:sqrid/:sqrxm/:sqsm/:by2/:by3/:by5?/:by6/:sqlsh/:path",
        component: () => import("@/views/spgl/dwsp_modal"),
        name: "dwsp_modal",
        meta: {
          title: "待我审批",
          icon: ""
        }
      },
      {
        path: "spjl",
        component: () => import("@/views/spgl/spjl"),
        name: "spjl",
        meta: {
          title: "审批记录",
          icon: ""
        }
      },
      {
        path:
          "spjl_modal/:spbId/:version/:spmbId/:sqrid/:sqrxm/:sqsm/:by2/:by3/:by6/:sqlsh/:path",
        component: () => import("@/views/spgl/spjl_modal"),
        name: "spjl_modal",
        meta: {
          title: "审批记录",
          icon: ""
        }
      }
    ]
  },
  {
    path: "/wdsq",
    component: Layout,
    redirect: "/wdsq/fqsq",
    meta: {
      title: "我的申请",
      icon: "el-icon-setting"
    },
    children: [
      {
        path: "nav/:path",
        component: () => import("@/views/manage/nav"),
        name: "nav",
        meta: {
          title: "导航",
          icon: "nav"
        }
      },
      {
        path: "fqsq",
        component: () => import("@/views/wdsq/fqsq"),
        name: "fqsq",
        meta: {
          title: "发起申请",
          icon: ""
        }
      },
      {
        path: "mbDownload",
        component: () => import("@/views/wdsq/mbDownload"),
        name: "mbDownload",
        meta: {
          title: "模板下载",
          icon: ""
        }
      },
      {
        path: "wdsq",
        component: () => import("@/views/wdsq/wdsq"),
        name: "wdsq",
        meta: {
          title: "我的申请",
          icon: ""
        }
      },
      {
        path: "dbsq_mode/:spmbId/:path/:mblx?/:mblxNum?/:sqlsh?/:id?/:sfsp?",
        component: () => import("@/views/wdsq/dbsq_mode"),
        name: "dbsq_mode_three",
        meta: {
          title: "申请",
          icon: ""
        }
      },
      {
        path: "dbsq_mode_gz/:spmbId/:path/:mblx?/:mblxNum?/:sqlsh?/:id?/:sfsp?",
        component: () => import("@/views/wdsq/dbsq_mode_gz"),
        name: "dbsq_mode_gz",
        meta: {
          title: "申请",
          icon: ""
        }
      },
      {
        path:
          "dbsq_mode_xnzz/:spmbId/:path/:mblx?/:mblxNum?/:sqlsh?/:id?/:sfsp?",
        component: () => import("@/views/wdsq/dbsq_mode_xnzz"),
        name: "dbsq_mode_xnzz",
        meta: {
          title: "申请",
          icon: ""
        }
      },
      {
        path: "dbsq_mode_mz/:spmbId/:path/:mblx?/:mblxNum?/:sqlsh?/:id?/:sfsp?",
        component: () => import("@/views/wdsq/dbsq_mode_mz"),
        name: "dbsq_mode_mz",
        meta: {
          title: "申请",
          icon: ""
        }
      },
      {
        path:
          "dbsq_mode_pldf/:spmbId/:path/:mblx?/:mblxNum?/:sqlsh?/:id?/:sfsp?",
        component: () => import("@/views/wdsq/dbsq_mode_pldf"),
        name: "dbsq_mode_pldf",
        meta: {
          title: "申请",
          icon: ""
        }
      },
      {
        path:
          "dbsq_mode_xjtx/:spmbId/:path/:mblx?/:mblxNum?/:sqlsh?/:id?/:sfsp?",
        component: () => import("@/views/wdsq/dbsq_mode_xjtx"),
        name: "dbsq_mode_xjtx",
        meta: {
          title: "申请",
          icon: ""
        }
      },
      {
        path:
          "dbsq_mode_xjsy/:spmbId?/:path?/:mblx?/:mblxNum?/:sqlsh?/:id?/:sfsp?",
        component: () => import("@/views/wdsq/dbsq_mode_xjsy"),
        name: "dbsq_mode_xjsy",
        meta: {
          title: "申请",
          icon: ""
        }
      },
      {
        path: "dbsq_mode_hp/:spmbId/:path/:mblx?/:mblxNum?/:sqlsh?/:id?/:sfsp?",
        component: () => import("@/views/wdsq/dbsq_mode_hp"),
        name: "dbsq_mode_hp",
        meta: {
          title: "申请",
          icon: ""
        }
      },
      {
        path:
          "dbsq_mode_bksq/:spmbId/:path/:mblx?/:mblxNum?/:sqlsh?/:id?/:sfsp?",
        component: () => import("@/views/wdsq/dbsq_mode_bksq"),
        name: "dbsq_mode_bksq",
        meta: {
          title: "申请",
          icon: ""
        }
      },
      {
        path: "dbsq",
        component: () => import("@/views/wdsq/dbsq"),
        name: "dbsq",
        meta: {
          title: "待办申请",
          icon: ""
        }
      },
      {
        //sqjl_modal
        path: "sqjl",
        component: () => import("@/views/wdsq/sqjl"),
        name: "sqjl",
        meta: {
          title: "申请记录",
          icon: ""
        }
      },
      {
        path:
          "sqjl_modal/:sqbId/:spmbId/:sqrid/:sqrxm/:sqlsh/:by2/:by3/:by5?/:by6/:path",
        component: () => import("@/views/wdsq/sqjl_modal"),
        name: "sqjl_modal",
        meta: {
          title: "申请记录",
          icon: ""
        }
      }
    ]
  },
  {
    path: "/",
    component: Layout,
    redirect: "/home",
    hidden: true
  },
  {
    path: "/home",
    component: Layout,
    redirect: "/home/home",
    meta: {
      title: "首页",
      icon: "el-icon-star-off"
    },
    children: [
      {
        path: "home",
        component: () => import("@/views/home/home"),
        name: "home",
        meta: {
          title: "首页",
          icon: "home"
        }
      }
    ]
  },
  {
    path: "/pzrz",
    component: Layout,
    redirect: "/pzrz/wrz",
    meta: {
      title: "凭证入账",
      icon: "el-icon-star-off"
    },
    children: [
      {
        path: "nav/:path",
        component: () => import("@/views/manage/nav"),
        name: "nav",
        meta: {
          title: "导航",
          icon: "nav"
        }
      },
      {
        path: "wrz",
        component: () => import("@/views/pzrz/wrz"),
        name: "wrz",
        meta: {
          title: "未入账",
          icon: "wrz"
        }
      },
      {
        path: "yrz",
        component: () => import("@/views/pzrz/yrz"),
        name: "yrz",
        meta: {
          title: "已入账",
          icon: "yrz"
        }
      },
      {
        path:
          "dbsq_mode/:path?/:mblx?/:mblxNum?/:sqlsh?/:sfsp?/:upShowhide?/:id?/:sfrz?/:rzId?",
        component: () => import("@/views/wdsq/dbsq_mode"),
        name: "dwpz_mode_three",
        meta: {
          title: "凭证",
          icon: ""
        }
      },
      {
        path:
          "dbsq_mode_gz/:path?/:mblx?/:mblxNum?/:sqlsh?/:sfsp?/:upShowhide?/:id?/:sfrz?/:rzId?",
        component: () => import("@/views/wdsq/dbsq_mode_gz"),
        name: "dwpz_mode_gz",
        meta: {
          title: "凭证",
          icon: ""
        }
      },
      {
        path:
          "dbsq_mode_xnzz/:path?/:mblx?/:mblxNum?/:sqlsh?/:sfsp?/:upShowhide?/:id?/:sfrz?/:rzId?",
        component: () => import("@/views/wdsq/dbsq_mode_xnzz"),
        name: "dwpz_mode_xnzz",
        meta: {
          title: "凭证",
          icon: ""
        }
      },
      {
        path:
          "dbsq_mode_mz/:path?/:mblx?/:mblxNum?/:sqlsh?/:sfsp?/:upShowhide?/:id?/:sfrz?/:rzId?",
        component: () => import("@/views/wdsq/dbsq_mode_mz"),
        name: "dwpz_mode_mz",
        meta: {
          title: "凭证",
          icon: ""
        }
      },
      {
        path:
          "dbsq_mode_pldf/:path?/:mblx?/:mblxNum?/:sqlsh?/:sfsp?/:upShowhide?/:id?/:sfrz?/:rzId?",
        component: () => import("@/views/wdsq/dbsq_mode_pldf"),
        name: "dwpz_mode_pldf",
        meta: {
          title: "凭证",
          icon: ""
        }
      },
      {
        path:
          "zfjg_modal1/:spbId/:version/:spmbId/:sqrid/:sqrxm/:sqsm/:by2/:by3/:by5?/:by6/:sqlsh+/:path",
        component: () => import("@/views/ynzl/zfjg_modal1"),
        name: "zfjg_modal1",
        meta: {
          title: "支付结果",
          icon: ""
        }
      },
      {
        path:
          "zfjg_modal2/:spbId/:version/:spmbId/:sqrid/:sqrxm/:sqsm/:by2/:by3/:by5?/:by6/:sqlsh+/:path/:detailId",
        component: () => import("@/views/ynzl/zfjg_modal2"),
        name: "zfjg_modal2",
        meta: {
          title: "支付结果",
          icon: ""
        }
      }
    ]
  },
  {
    path: "/rzgl",
    component: Layout,
    redirect: "/rzgl/dlrz",
    meta: {
      title: "日志管理",
      icon: "el-icon-star-off"
    },
    children: [
      {
        path: "nav/:path",
        component: () => import("@/views/manage/nav"),
        name: "nav",
        meta: {
          title: "导航",
          icon: "nav"
        }
      },
      {
        path: "dlrz",
        component: () => import("@/views/rzgl/dlrz"),
        name: "dlrz",
        meta: {
          title: "登录日志",
          icon: "dlrz"
        }
      },
      {
        path: "czrz",
        component: () => import("@/views/rzgl/czrz"),
        name: "czrz",
        meta: {
          title: "操作日志",
          icon: "czrz"
        }
      }
    ]
  },
  {
    path: "/cwgk",
    component: Layout,
    redirect: "/cwgk/cmzzsw",
    meta: {
      title: "村务公开",
      icon: "el-icon-message"
    },
    children: [
      {
        path: "nav/:path",
        component: () => import("@/views/manage/nav"),
        name: "nav",
        meta: {
          title: "导航",
          icon: "nav"
        }
      },
      {
        path: "cmzzsw",
        component: () => import("@/views/cwgk/cmzzsw"),
        name: "cmzzsw",
        meta: {
          title: "村民自治事物",
          icon: "cmzzsw"
        }
      },
      {
        path: "cjzw",
        component: () => import("@/views/cwgk/cjzw"),
        name: "cjzw",
        meta: {
          title: "村级政务",
          icon: "cjzw"
        }
      },
      {
        path: "xxfkgl",
        component: () => import("@/views/cwgk/xxfkgl"),
        name: "xxfkgl",
        meta: {
          title: "信息反馈管理",
          icon: "xxfkgl"
        }
      }
    ]
  },
  {
    path: "/bfxx",
    component: Layout,
    redirect: "/bfxx/cnxx",
    meta: {
      title: "拨付信息",
      icon: "el-icon-message"
    },
    children: [
      {
        path: "nav/:path",
        component: () => import("@/views/manage/nav"),
        name: "nav",
        meta: {
          title: "导航",
          icon: "nav"
        }
      },
      {
        path: "cnxx",
        component: () => import("@/views/bfxx/cnxx"),
        name: "cnxx",
        meta: {
          title: "出纳信息",
          icon: "cnxx"
        }
      }
    ]
  },
  {
    path: "/mark",
    component: Layout,
    redirect: "/mark/mdList",
    meta: {
      title: "公示管理",
      icon: "el-icon-star-off"
    },
    children: [
      {
        path: "markdown/:id?/:isUpdate?",
        component: () => import("@/views/mark/markdown"),
        name: "markdown",
        hidden: true,
        meta: {
          title: "发布信息",
          icon: "markdown"
        }
      },
      {
        path: "mdList",
        component: () => import("@/views/mark/mdList"),
        name: "mdList",
        meta: {
          title: "公示管理",
          icon: "mdList"
        }
      },
      {
        path: "readme",
        component: () => import("@/views/mark/readme"),
        name: "readme",
        meta: {
          title: "预览",
          icon: "readme"
        }
      }
    ]
  },
  {
    path: "/yjgl",
    component: Layout,
    redirect: "/yjgl/zdyyjgz",
    meta: {
      title: "预警管理",
      icon: "el-icon-star-off"
    },
    children: [
      {
        path: "nav/:path",
        component: () => import("@/views/manage/nav"),
        name: "nav",
        meta: {
          title: "导航",
          icon: "nav"
        }
      },
      {
        path: "zdyyjgz",
        component: () => import("@/views/yjgl/zdyyjgz"),
        name: "zdyyjgz",
        meta: {
          title: "自定义预警规则",
          icon: "markdown"
        }
      },
      {
        path: "zjyj",
        component: () => import("@/views/yjgl/zjyj"),
        name: "zjyj",
        meta: {
          title: "资金预警",
          icon: "zjyj"
        }
      }
    ]
  }
];
export default new Router({
  // mode: "history",
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRouterMap
});
